import React from "react";
import PropTypes from "prop-types";
import LayoutHead from "../LayoutHead";
import styles from "./index.module.css";
import isBrowserEnv from "../../utils/isBrowserEnv";

const Chapter = ({ titleNumber, title, subTitle, text }) => {
  let here;
  if (isBrowserEnv() && window.location.href) here = window.location.href;
  return (
    <div className={styles.root}>
      <LayoutHead>
        <title>{title} - The State of European Tech 2017</title>
        <meta property="og:description" content={title} />
        <meta property="og:url" content={here} />
        <meta name="twitter:description" content={title} />
        <meta name="description" content={title} />
      </LayoutHead>
      <h1 data-chapter={titleNumber} className={styles.title}>
        {title}
      </h1>
      <div className={styles.chapterContent}>
        <div className={styles.chapterContentInner}>
          <span className={styles.divider} />
          <h2 className={styles.subTitle}>{subTitle}</h2>
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>
      </div>
    </div>
  );
};

Chapter.propTypes = {
  nextPath: PropTypes.string,
  titleNumber: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  text: PropTypes.string
};

export default Chapter;



// WEBPACK FOOTER //
// ./src/components/Chapter/index.js